import React from 'react'
import moment from 'moment'
import Back from '../Back/Back'
import "./ManageTitle.css"
import favicon from "../../Assets/favicon.ico"
import Button from '../Button/Button'
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch'
import { formatDate } from '../../helper/formatDate'
import { useLocation, useNavigate } from 'react-router-dom'

// toggleLabel/toggleChecked/onToggle are prop-gated (no existing caller sets
// them): they render a labeled ToggleSwitch in the header button row — the
// live publish toggle on ManageFeisGrade.
const ManageTitle = (props) => {
    const { eventLogo, eventName, eventType, eventDate, button, textButton, className, className1, onClick, textBtnHandler, loading, textBtnClass, onBackClick, button1, toggleLabel, toggleChecked, onToggle } = props
    const eventDateConverted = moment(formatDate(eventDate)).format(" MMMM Do, YYYY")

    const navigate = useNavigate()
    const location = useLocation()
    const eventId = new URLSearchParams(location.search).get('id')

    // Clicking the event logo returns to THIS event's dashboard (the manage
    // tiles page) when the page URL carries the event id; otherwise fall back
    // to the events list as before.
    const navigateToDashboard = () => {
        // Three event types, not two — an unrecognised type must NOT fall
        // through to the grade dashboard (it renders "Grade Exam / Invalid
        // date" and offers grade Approve/Delete against a foreign event id).
        if (eventId) {
            if (eventType === "Oireachtas") navigate(`/oireachtas/manage?id=${eventId}`)
            else if (eventType === "Feiseanna") navigate(`/feis/manage?id=${eventId}&Manage=feis`)
            else navigate(`/grade/manage?id=${eventId}&Manage=grade`)
            return
        }
        if (eventType === "Oireachtas") navigate("/oireachtas")
        else eventType === "Feiseanna" ? navigate("/feis") : navigate("/grade")
    }

    const renderTitle = () => {
        return <>
            <div className="my-3"><Back onBackClick={onBackClick} /></div>
            <div className="d-flex align-items-center gap-2 my-2">
                <img className="manage-title-img" src={eventLogo ? eventLogo : favicon} alt="" title="Back to event dashboard" onClick={navigateToDashboard} />
                <div className="org-title-name">{eventName}</div>
            </div>
            <div className="d-flex align-items-center gap-2 my-2 mb-4">
                <div className="manage-title-type">{eventType === "Feiseanna" ? "Feisanna" : eventType === "Oireachtas" ? "Oireachtas" : "Grade Exam"}</div>
                <div className="manage-title-date">{eventDateConverted}</div>
            </div>
        </>
    }

    return (
        <>
            {!button && !textButton &&
                <div className="manage-header">
                    <div className={loading ? "invisible" : ""}>{renderTitle()}</div>
                </div>
            }
            {((button && !textButton && !button1 && !toggleLabel) || (!button && textButton && !button1 && !toggleLabel)) &&
                <div className="manage-header">
                    <div className={loading ? "invisible" : "title-with-btn"}>
                        <div >{renderTitle()}</div>
                        <div className="title-btn-div mb-4">
                            {button && !textButton && <Button className={className} onClick={onClick}>{button}</Button>}
                            {!button && textButton && <Button className={textBtnClass || className} onClick={textBtnHandler}>{textButton}</Button>}
                        </div>
                    </div>
                </div>
            }

            {((button && textButton) || (button && button1) || (button && toggleLabel)) && <div className="manage-header">
                <div className={loading ? "invisible" : "title-with-btn"}>
                    <div style={{ width: "100%" }}>
                        <div className="my-3"><Back onBackClick={onBackClick} /></div>
                        <div className="d-flex align-items-center gap-2 my-2">
                            <img className="manage-title-img" src={eventLogo ? eventLogo : favicon} alt="" title="Back to event dashboard" onClick={navigateToDashboard} />
                            <div className="org-title-name">{eventName}</div>
                        </div>
                        <div className="d-md-flex justify-content-between align-items-start">
                            <div className="d-flex align-items-center gap-2 my-0 ">
                                <div className="manage-title-type">{eventType === "Feiseanna" ? "Feisanna" : eventType === "Oireachtas" ? "Oireachtas" : "Grade Exam"}</div>
                                <div className="manage-title-date">{eventDateConverted}</div>
                            </div>
                            <div className="title-btn-div d-flex align-items-center justify-content-between mb-1 gap-2">
                                {toggleLabel && <div className="d-flex align-items-center gap-2">
                                    <span className="manage-title-type">{toggleLabel}</span>
                                    <ToggleSwitch checked={toggleChecked} onChange={onToggle} />
                                </div>}
                                <div>
                                    {textButton && <Button className={textBtnClass ? textBtnClass : "text-btn px-0"} onClick={textBtnHandler}>{textButton}</Button>}
                                    {/* using textBtnHandler as name for 2nd button to reduce prop counts */}
                                    {button1 && <Button className={className1} onClick={textBtnHandler}>{button1}</Button>}
                                </div>
                                <div>
                                    <Button className={className} onClick={onClick}>{button}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}

            <div className="hr-org-title" />
        </>
    )
}

export default ManageTitle